// src/components/ImageCarousel.js

import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const ImageCarouselComponent = ({ images }) => {
  return (
    <div className='Image-Carousel'>
    <Carousel autoPlay infiniteLoop showArrows={true} showThumbs={false}>
      {images.map((image, index) => (
        <div key={index} style={{maxHeight:'450px',maxWidth:'auto'}}>
          <img src={image} alt={`Image ${index}`} style={{ maxHeight: '450px', maxWidth: 'auto' }} />
        </div>
      ))}
    </Carousel>
    </div>
   
  );
};

export default ImageCarouselComponent;

